import 'zone.js/dist/zone.js'

import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import '@angular/localize/init'
import { AppModule } from './root/app.module'
import { BOOTSTRAP_DATA } from './api/module'

import '../static/vendor/babel-helpers'
import './common/babel-helpers-override'

import './utils'

import '../theme/index.scss'
import '../theme/toastr.scss'

import '../static/overrides/angular-image-crop.css'
import '../static/overrides/angular-loading-bar.css'
import '../static/vendor/akkurat-light/stylesheet.css'
import '../static/vendor/bootstrap-datepicker4.scss'

import '../static/lib/css/animate.scss'

import 'main/css/app.scss'
import 'src/media/css/styles.scss'
import 'src/media/css/ratings.scss'
import { BootstrapDataFromJSON } from 'elements-sdk'
import { Logger } from 'common/log'

const failBootstrap = (error) => {
  console.error(error)
  const e = document.getElementById('angular-bootstrap-error')
  e!.style.display = 'block'
  e!.querySelector('code')!['innerText'] = error.constructor?.name
  e!.querySelector('pre.a')!['innerText'] = error.message
}

window['bootstrapData'].then(async bootstrapData => {
  const style = 'background: yellow; width: 20px; height: 20px; display: inline-block;'
  const reset = 'background: transparent;'
  console.log('  %c    \n%c  \n%c  %c    \n%c  \n%c  %c    ', style, style, reset, style, style, reset, style)

  const logger = new Logger(__filename)

  logger.group(`Welcome to ELEMENTS ${bootstrapData.version.release}`)
  console.log('https://elements.tv')
  console.log('service@elements.tv')
  console.log('')
  console.log('💡 Check out our SDK: https://python.sdk.elements.tv/ and the API playground in your Profile > API > Playground')
  console.log('Or take a peek in the Network tab - it\'s all the same thing.')
  logger.groupEnd()

  if (bootstrapData.license?.expiry) {
    bootstrapData.license.expiry = new Date(bootstrapData.license.expiry)
  }

  window['debug'] = bootstrapData.debug
  if (!bootstrapData.debug) {
    enableProdMode()
  }

  try {
    platformBrowserDynamic([
      { provide: BOOTSTRAP_DATA, useValue: BootstrapDataFromJSON(bootstrapData) },
    ]).bootstrapModule(AppModule)
  } catch (error) {
    failBootstrap(error)
    throw error
  }

  if (window.isSecureContext) {
    try {
      await navigator.serviceWorker.register('/serviceWorker.js')
    } catch (error) {
      console.warn('Could not install the Service Worker:', error)
    }
  }
}).catch((error) => {
  failBootstrap(error)
})
